import React from "react"
import Table from "../../../../components/common/Table"
import { TableHeaderColumn, TableRow, TableHeader, TableRowColumn, TableBody } from "material-ui"
import strings from "../../../../localization/strings"
import { IAccountManagerUserDocument } from "../../../../models"

interface IProps {
	users: IAccountManagerUserDocument[]
	selectedUsers: IAccountManagerUserDocument[]
	offset: number
	limit: number
	total: number
	limitOptions: number[]
	onPageClick(offset: number): void
	onLimitChange(limit: number): void
	handleSelectUser(selectedUsers: IAccountManagerUserDocument[]): void
	handleEditUser(editUser: IAccountManagerUserDocument): void
}

const styles = {
	columnValue: {
		cursor: "pointer",
		paddingLeft: "8px",
		paddingRight: "8px"
	},
	columnHeader: {
		paddingLeft: "8px",
		paddingRight: "8px",
		whitespace: "normal"
	},
	tableStyle: {
		overFlowY: "visible"
	}
}

const AccountManagerUsersTabUsersTable: React.SFC<IProps> = (props: IProps) => {
    return (
        !props.users.length ?
            <h2 style={{ textAlign: "center", marginTop: 25 }}>
                {strings.No_User_Found}
            </h2>
        :
        <Table 
            items={props.users} 
            allowClickRow
            singleSelectable
            handleClickRow={row => props.handleEditUser(row)}
            handleSelect={props.handleSelectUser}
            total={props.total}
            offset={props.offset}
            limit={props.limit}
            limitOptions={props.limitOptions}
            onPageClick={props.onPageClick}
            onLimitChange={props.onLimitChange}
        >
            <TableHeader>
                <TableRow>
                    <TableHeaderColumn style={styles.columnHeader}>{strings.First_Name}</TableHeaderColumn>
                    <TableHeaderColumn style={styles.columnHeader}>{strings.Last_Name}</TableHeaderColumn>
                    <TableHeaderColumn style={styles.columnHeader}>{strings.Permissions}</TableHeaderColumn>
                </TableRow>
            </TableHeader>
            <TableBody showRowHover={true} deselectOnClickaway={false}>
                {props.users.map((row, index) => {
                    const permissionsCount = row.UserRole && row.UserRole.Permissions ? row.UserRole.Permissions.length : 0
                    return (
                        <TableRow key={index} selected={props.selectedUsers.find(user => user.Id === row.Id) ? true : false}>
                            <TableRowColumn style={styles.columnValue}>{row.FirstName}</TableRowColumn>
                            <TableRowColumn style={styles.columnValue}>{row.LastName}</TableRowColumn>
                            <TableRowColumn style={styles.columnValue}>{permissionsCount === 7 ? `${strings.All} ${strings.Permissions}` : `${permissionsCount} ${strings.Permissions}`}</TableRowColumn>
                        </TableRow>
                    )
                })}
            </TableBody>
        </Table>
    )
}

export default AccountManagerUsersTabUsersTable

